import { connect } from 'react-redux';
import { IContentBySearchState, IEnv } from '../../store';
import { Main } from '../presentation/Main';
import { IResult } from '../../data/data';
import { EnvUpdateAction } from '../../store/actions/EnvUpdateAction';

interface PropsFromState {
  items: IResult[];
}

interface PropsFromDispatch {
  importEnv: () => void;
}

interface OwnProps {
  env: IEnv;
}

export interface IMainProps {
  importEnv: () => void;
  env: IEnv;
  items: IResult[];
}

const mapStateToProps = (state: IContentBySearchState) => ({
  items: state.items.map(item => item),
  env: state.env
});

const mapDispatchToProps = (dispatch: any, ownProps: OwnProps) => ({
  importEnv: () => {
    dispatch(EnvUpdateAction(ownProps.env));
  }
});

export const ContentBySearchContainer = connect<
  PropsFromState,
  PropsFromDispatch,
  OwnProps
>(
  mapStateToProps,
  mapDispatchToProps
)(Main);
